import { render, staticRenderFns } from "./BgFormWrapper.vue?vue&type=template&id=6719fda8"
import script from "./BgFormWrapper.vue?vue&type=script&lang=js"
export * from "./BgFormWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports